import type { ApiError } from '@mas-flow/types';

export class ApiHttpError extends Error {
  override readonly name = 'ApiHttpError';
  constructor(
    readonly status: number,
    readonly payload: ApiError | undefined,
    message?: string,
  ) {
    super(message ?? `API ${status}`);
  }
}

export async function apiGet<T>(path: string): Promise<T> {
  const res = await fetch(path, { credentials: 'include' });
  if (!res.ok) {
    const payload = await safeJson<ApiError>(res);
    throw new ApiHttpError(res.status, payload);
  }
  return (await res.json()) as T;
}

async function safeJson<T>(res: Response): Promise<T | undefined> {
  try {
    return (await res.json()) as T;
  } catch {
    return undefined;
  }
}
